import { ContestGroupModule } from '@/modules/fantasy/contest-group';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/fantasy/contest-group')({
  component: ContestGroupPage,
});

function ContestGroupPage() {
  return <ContestGroupModule />;
}
